import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { UserService } from '../shared/services/user.service';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/shared/services/toast.service';
import { UserAvailabilityComponent } from '../user-availability/user-availability.component';
import { UserLobbySettingsComponent } from '../user-lobby-settings/user-lobby-settings.component';
import { UserAdditionalSettingsComponent } from '../user-additional-settings/user-additional-settings.component';
import { UserSkillsComponent } from '../user-skills/user-skills.component';
import { IListItemModel } from '../shared/models/listItemModel';
import { Store } from '@ngrx/store';
import { getACLicenseStatus, getLTLicenseStatus } from '../../../state/index';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/shared/models/store models/app-state.interface';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';
import { TranslateService } from '@ngx-translate/core';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap'; 

@Component({
  selector: 'app-manage-settings',
  templateUrl: './manage-settings.component.html',
  styleUrls: ['./manage-settings.component.scss']

})

export class ManageSettingsComponent implements OnInit {
  public isExpandable: boolean = false;
  public isDirty: boolean = false;
  public pageTitle: string = '';
  public show: boolean = false;
  public anchor: any;
  view: any;
  activeIds: string[] = ["ngb-panel-0"];
  public userTitleTranslate: any;
  collapsedTitle: string | undefined;

  isACLicenseEnabled$: Observable<boolean>;
  isLTLicenseEnabled$: Observable<boolean>;

  constructor(public fb: FormBuilder,
    private router: Router,
    private store: Store<AppState>,
    public userService: UserService,
    private toastService: ToastService, 
    private translationLoaderFacade: TranslationLoaderFacade, 
    private translateService: TranslateService,
  ) {
    this.isACLicenseEnabled$ = new Observable<boolean>();
    this.isLTLicenseEnabled$ = new Observable<boolean>();
    this.translateService.get(['_General_Add_User_Text_', '_User_Edit_User_Ts_Text_', '_Product_Services_Add_Save_Info_Title_Text_']).subscribe((translations) => {
      this.userTitleTranslate = [
        {id:1, value: translations['_General_Add_User_Text_']}, 
        {id:2, value: translations['_User_Edit_User_Ts_Text_']}
      ],
      this.collapsedTitle = translations['_Product_Services_Add_Save_Info_Title_Text_'];
     });
  }
  @ViewChild(UserAvailabilityComponent) availability: UserAvailabilityComponent | undefined;
  @ViewChild(UserLobbySettingsComponent) lobby: UserLobbySettingsComponent | undefined;
  @ViewChild(UserAdditionalSettingsComponent) appointment: UserAdditionalSettingsComponent | undefined;
  @ViewChild(UserSkillsComponent) skills: UserSkillsComponent | undefined;
  @ViewChild('acc') accordion!: NgbAccordion;

  ngOnInit() {
    this.isLTLicenseEnabled$ = this.store.select(getLTLicenseStatus);
    this.isACLicenseEnabled$ = this.store.select(getACLicenseStatus);
    let editingUser = this.userService.getEditingUser();
    if (editingUser) {
        this.isExpandable = false;
        this.pageTitle = this.userTitleTranslate[1].value + ' ' + editingUser.userDetails.firstName + ' ' + editingUser.userDetails.lastName; 
    } else {
      this.isExpandable = true;
      this.pageTitle = this.userTitleTranslate[0].value;
    }
    this.activeIds = ["ngb-panel-0"];
  }

  /**
  * Navigate to the edit view after creating the user using Save and Continue button
  */
  public asyncUserUpdate() {
    let editingUser = this.userService.getEditingUser();
    if (editingUser) {
      this.isExpandable = false;
      this.pageTitle = this.userTitleTranslate[1].value + ' ' + editingUser.userDetails.firstName + ' ' + editingUser.userDetails.lastName; 
      this.loadUserTabData();
      this.closeAllAccorionPanels();
    } else {
      this.isExpandable = true;
      this.pageTitle = this.userTitleTranslate[0].value;
    }
  }

  /**
   * Load user tab data
   */
  public loadUserTabData() {
    if (this.availability) {
      this.availability.loadAvailabilityTemplateData();
    }
    if (this.appointment) {
      this.appointment.loadAppointmentSettings();
    }
    if (this.lobby) {
      this.lobby.loadLobbySettings();
    }

    if (this.skills) {
      this.skills.loadUserSkills();
    }

  }

  /**
   * Close all the panels in the accorion 
   */
  public closeAllAccorionPanels() {
      setTimeout(() => {
    this.activeIds.forEach(panelId => {
      this.accordion.collapse(panelId);
    });

    this.activeIds = [];
  });
  }

  /**
   *  Update the "dirty" of the parent based on the child forms dirty attribute 
   */
  public updateFormDirty(event: boolean) {
    this.isDirty = event;
  }

  public changeFloatValue() {
    this.availability?.setLocationSelecorValue();
  }

  public updateValue(event: boolean) {
    this.isExpandable = false;
  }

  public hasUnsavedData(): boolean {
    return this.isDirty;
  }

  public changeUseAppointmentValue(value: boolean) {
    if (this.availability == undefined) {
      throw Error("this.availability was undefined! Which was not expected!")
    }
    this.availability.appointmentsEnabled = value;
  }

  public changeMeetingPreferenceSelection(meetingPreferenceSelection: Array<IListItemModel>) {
    this.availability?.onMeetingPreferenceSelectionChange(meetingPreferenceSelection);
  }

  /**
   * Navigate to the users grid
   */
  public gotoUserGrid() {
    this.router.navigate(['/admin/user']);
  }

  /**
   * Reassign selected meeting preference with different meeting preference option
   */
  public reassignMeetingPreference(meetingPreferenceReassignModle: any) {
    this.availability?.reassignMeetingPreference(meetingPreferenceReassignModle.reassign, meetingPreferenceReassignModle.as);
  }

}
